import UserState from './state.interface';

const InitialUserState: UserState = {
    validationPassword: false,
    isTestUserPasswordCorrect: false,

    validatingUserEmail: false,
    validatingUserEmailSuccess: false,
    validatingUserEmailFailure: '',

    creatingPassword: false,
    creatingPasswordSuccess: '',
    creatingPasswordFailure: '',

    loggingIn: false,
    loggingInSuccess: false,
    loggingInFailure: '',

    resendError: null,
    resendingVerification: false,
    resentVerification: false,
    resendVerificationSuccess: null,

    requires2FA: false,
};

export default InitialUserState;
